import { Component } from '@angular/core';

@Component({
  selector: 'ngx-users',
  template: `<router-outlet></router-outlet>`,
})
export class UsersComponent {
}
